/**
 * created by yxy
 * 阵地维护
 */
import React from "react";
import BaseComponent from "../../../../../base/BaseComponent";
import Card from './card.js'
import PageTemplate from "../../../components/pageTemplate/PageTemplate";
import { Empty} from 'antd';
import {uuid} from "../../../../../utils";
import PositionLevel from "../../positionStatisticAnalysis/components/positionLevel";
import {Scrollbars} from "react-custom-scrollbars";


export default class Schedule extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            currentTabs:'',
            dataSource:[]
        };
    }
    componentDidMount() {
        this.getList()

    }

    getList = () =>{
        let body ={};
        if(this.state.currentTabs){
            body.grade = this.state.currentTabs
        }else{
            delete body.grade
        }
        this.request({
            url: '/cm-sites-media-consumer/position/overview/position',
            method: "get",
            contentType: "json",
            body: body,
            callBack: (data) => {
                 let   dataSource = [];
                 if(data&&data.length){
                     dataSource = data
                 }
                 this.setState({dataSource})

            }
        });
    };

    componentWillUnmount() {

    }



    render() {
        let {dataSource } =this.state;
       return(

           <PageTemplate style={{padding: 0}}>
               <PositionLevel
                   callBack={(data) => {
                       let key = uuid();
                       window.loading.show(null, key);
                       setTimeout(() => {
                           this.setState({page: 1, currentTabs: data}, () => {
                               this.getList();
                               this.props.callBack && this.props.callBack(this.state.currentTabs)
                           });
                           window.loading.hide(key);
                       }, 1000);

                   }}>
               </PositionLevel>
               <PageTemplate style={{padding: 15}}>
                   <Scrollbars autoHide autoHeight autoHeightMax={300}>
                       {dataSource && dataSource.length > 0?<div style={{
                           display: 'grid',
                           justifyContent: 'space-between',
                           gridTemplateColumns: ' repeat(auto-fill, 247px)',
                       }}>
                           { dataSource.map((item,index)=>{
                               return  <Card item={item} key={index}></Card>
                               }
                           )}


                       </div>:<Empty/>}

                   </Scrollbars>
               </PageTemplate>
           </PageTemplate>

       )
    }

    onChange = (val) => {
        this.setState({currentTab: val})
    }
}